<script>
  export let href = '';
  export let styles = {};
  let className = '';
  export { className as class };
  export let hover = true;

  $: style = Object.entries(styles).reduce((acc, [k, v]) => {
    return acc + `--${k}: ${v};`;
  }, '');
</script>

{#if href}
  <a class="pill-button {className}" class:with-hover={hover} on:click {href} {style}>
    <span><slot>See more</slot></span>
  </a>
{:else}
  <button class="pill-button {className}" class:with-hover={hover} on:click {style} type="button">
    <span><slot>See more</slot></span>
  </button>
{/if}

<style lang="scss">
  .pill-button {
    display: inline-block;
    position: relative;
    width: var(--width, 265px);
    height: 45px;
    background: var(--background, #fa4616);
    border: none;
    border-radius: 50px;
    color: var(--color, #fff);
    font-size: 20px;
    line-height: 45px;
    overflow: hidden;
    text-align: center;
    text-decoration: none;

    transition: background 0.2s ease-in-out;
  }

  .pill-button::before {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: var(--background-hover, linear-gradient(250deg, #fa4616 49.63%, #fea300 83.58%));
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  .pill-button:hover::before {
    opacity: 1;
  }

  span {
    position: relative;
  }
</style>
